import {AdminTitle} from "../../store/reducers/site";
import NewsHome from "./newsHome";
const Home = () => {
    return(
        <>
         <AdminTitle title="News "/>
         <NewsHome/>
        </>
    )
}

export default Home;